module.exports = __webpack_public_path__ + "static/OKEx-5f02fda05efe098cc7337f3a2cb574ae.png";